import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store/store'
import locales from './i18n/locales'
import datetime from './i18n/datetime'
import ApiService from '@/services/ApiService'

Vue.use(VueI18n)

let languages = {
  browser: {
    exact: 'de' || '',
    loose: ('de' || '').substr(0, 2)
  },
  available: {
    exact: Object.keys(locales),
    loose: Object.keys(locales).map(locale => locale.substr(0, 2))
  }
}

let moduleOptions = {
  locale: getInitialLanguage(),
  // Preferred Locale if a Translation-Key is not available in CurrentLanguage
  // If not set, locale Key will be rendered
  fallbackLocale: languages.available.exact[0],
  messages: locales,
  dateTimeFormats: datetime
}

let i18n = new VueI18n(moduleOptions)

// Set initial i18n store configuration
store.commit(
  'ui/setI18n',
  Object.assign(
    { AVAILABLE: languages.available },
    { locale: moduleOptions.locale }
  )
)

// Change i18n "locale" if store "locale" changes
store.watch(
  () => store.getters['ui/getLocale'],
  locale => {
    Vue.set(i18n, 'locale', locale)
    ApiService.setLocale(locale)
  }
)

function getInitialLanguage() {
  let initialLanguage = ''

  if (languages.available.exact.includes(languages.browser.exact)) {
    // Set Browserlanguage (exact)
    initialLanguage = languages.browser.exact
  } else if (languages.available.loose.includes(languages.browser.loose)) {
    // Set Browserlanguage (loose)
    initialLanguage =
      languages.available.exact[
        languages.available.loose.findIndex(l => l === languages.browser.loose)
      ]
  } else {
    // Set Defaultlanguage
    initialLanguage = languages.available.exact[0]
  }

  return initialLanguage
}

export { i18n as default, languages }
